import { env } from 'next-runtime-env';

import { defaultLocale, type RouterLocale } from '~shared/constants/i18n';

// eslint-disable-next-line no-restricted-syntax
export const isSafeApp = process.env.NEXT_PUBLIC_SAFE?.toLowerCase() === 'true';

export const getOrigin = (): string => {
	const sfwOrigin = env('NEXT_PUBLIC_SAFE_APP_HOST_URL') ?? 'https://joi.ai';
	const nsfwOrigin = env('NEXT_PUBLIC_APP_HOST_URL') ?? 'https://joi.com';
	const appOrigin = isSafeApp ? sfwOrigin : nsfwOrigin;

	return appOrigin;
};

export const getSFWOrigin = (): string => {
	return env('NEXT_PUBLIC_SAFE_APP_HOST_URL') ?? 'https://joi.ai';
};

export const getNSFWOrigin = (): string => {
	return env('NEXT_PUBLIC_APP_HOST_URL') ?? 'https://joi.com';
};

export const getHost = (): string => {
	return getAppUrl().hostname;
};

export const isDev = (): boolean => {
	return !!env('NEXT_PUBLIC_DEV');
};

export const isHostLocal = (host: string): boolean => {
	return (
		host.includes('localhost') ||
		host.includes('192.168') ||
		host.includes('10.')
	);
};

export const getSubdomainUrlStr = (
	subdomain: string,
	appUrl: URL = getAppUrl()
): string => {
	const baseHostname = appUrl.hostname;
	appUrl.hostname = `${subdomain}.${baseHostname}`;

	return appUrl.toString();
};

export const getAppUrl = (): URL => new URL(getOrigin());

export const getLocalizedAppUrl = (locale: RouterLocale): string => {
	const url = getAppUrl();

	if (locale !== defaultLocale) {
		url.hostname = `${locale}.${url.hostname}`;
	}

	return url.toString().replace(/\/$/, '');
};
